"use client"

import styled from "@emotion/styled"
import { GetPageByRouteQuery } from "apollo"
import { Desktop, Mobile } from "ui"
import Container from "ui/Container"
import { getBreadCrumbs, transformProperties } from "utils"
import Hero from "../Common/Hero"
import BasicContentComponent from "./BasicContentComponent"
import FormComponent from "./FormComponent"
import HoursContactInfo from "./HoursContactInfo"
import StickyForm from "./StickyForm"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 64px;
    display: grid;
    grid-template-columns: 1fr 381px;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default function DriversCareer({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  const heroBanner = blocks?.blocks?.find(
    (block: any) => block.blockType === "heroBanner",
  )
  const adynamicTitleAndContant = blocks?.blocks?.find(
    (block: any) => block.blockType === "adynamicTitleAndContant",
  )
  const contactUs = blocks?.blocks?.find(
    (block: any) => block.blockType === "contactUs",
  )
  const basicBannerModule = blocks?.blocks?.find(
    (block: any) => block.blockType === "BasicBannerModule",
  )
  return (
    <>
      <Hero data={heroBanner} breadCrumbs={breadCrumbs} />
      <Container paddingMobile={true}>
        <StyledLayout>
          <StyledWrapper>
            <FormComponent
              data={adynamicTitleAndContant}
              isDriversPage={true}
            />
            <HoursContactInfo data={contactUs} />
          </StyledWrapper>
          <Desktop>
            <StickyForm isDriversPage={true} />
          </Desktop>
        </StyledLayout>
      </Container>
      <BasicContentComponent data={basicBannerModule} locale={locale} />
      <Mobile>
        <StickyForm isDriversPage={true} />
      </Mobile>
    </>
  )
}
